module.exports = __webpack_public_path__ + "static/media/47.f59e44f9.jpg";